document.addEventListener("DOMContentLoaded", function () {
  const MIN_BRODERIE_QTY = 20;
  const MIN_ORDER = 200;
  // Nota B2B din banner: pragul minim trebuie sa apara INTOTDEAUNA impreuna cu scopul
  // ofertei, altfel arata ca o conditie impusa consumatorului. Vezi si subsolul si cosul.
  const B2B_NOTA = '<div style="margin-top:6px;font-weight:400;opacity:.85">Ofert\u0103 destinat\u0103 clien\u021bilor profesionali.</div>';

  function isBroderieItem(item) {
    // Liniile de serviciu/setup (naturif-personalizare) nu sunt bucăți de textil.
    const role = item.properties && item.properties._nf_role;
    if (role === "s" || role === "u") return false;
    return Object.values(item.properties || {}).some(
      (v) => typeof v === "string" && v.toLowerCase().includes("broderie")
    );
  }

  // Grupează cantitatea de broderie din coș pe fiecare produs.
  function getBroderieGroupsFromCart(cart) {
    const groups = {};
    cart.items.filter(isBroderieItem).forEach((item) => {
      const key = String(item.product_id);
      if (!groups[key]) groups[key] = { productId: item.product_id, title: item.product_title, qty: 0 };
      groups[key].qty += item.quantity;
    });
    return Object.values(groups);
  }

  function broderieNoticeText(qty) {
    const remaining = MIN_BRODERIE_QTY - qty;
    if (remaining <= 0) {
      return { ok: true, text: `✓ Minim de ${MIN_BRODERIE_QTY} buc. broderie atins` };
    }
    return {
      ok: false,
      text: `⚠ Broderie: ai ${qty}/${MIN_BRODERIE_QTY} buc. — comanda minimă pentru broderie este ${MIN_BRODERIE_QTY} buc. per produs (poți combina mai multe mărimi)`,
    };
  }

  function styleNotice(el, ok) {
    el.style.cssText =
      "margin: 10px 0; padding: 10px 14px; border-radius: 8px; font-size: 13px; font-weight: 500; text-align: center;" +
      (ok
        ? "background:#f0fdf4; color:#16a34a; border:1px solid #bbf7d0;"
        : "background:#fff7ed; color:#ea580c; border:1px solid #fed7aa;");
  }

  // ---------------------------------------------------------------------
  // Widget de personalizare (doar pe pagina de produs)
  // ---------------------------------------------------------------------
  const calculator = document.getElementById("calculator-form-container");
  let validateAddToCart = function () { return Promise.resolve(false); };

  if (calculator) {
    (function () {
      function togglePositionare(show) {
        calculator.querySelectorAll(".calc-row").forEach((row, index) => {
          if (index !== 0) row.style.display = show ? "" : "none";
        });
      }
      togglePositionare(false);

      function getProductId() {
        const el = document.querySelector("[data-product-id]");
        return el ? el.getAttribute("data-product-id") : null;
      }

      function isBroderieSelected() {
        const radios = calculator.querySelectorAll('input[type="radio"]');
        const selected = Array.from(radios).find((r) => r.checked);
        const label = selected ? (selected.closest("label") || selected.parentElement) : null;
        return (label ? label.textContent.trim().toLowerCase() : "").includes("broderie");
      }

      let noticeEl = null;
      function removeProductNotice() {
        if (noticeEl) {
          noticeEl.remove();
          noticeEl = null;
        }
      }

      async function refreshProductNotice() {
        if (!isBroderieSelected()) {
          removeProductNotice();
          return;
        }
        const productId = getProductId();
        let qty = 0;
        if (productId) {
          try {
            const cart = await fetch("/cart.js").then((r) => r.json());
            const groups = getBroderieGroupsFromCart(cart);
            const g = groups.find((g) => String(g.productId) === String(productId));
            qty = g ? g.qty : 0;
          } catch (e) {}
        }
        if (!noticeEl) {
          noticeEl = document.createElement("div");
          noticeEl.id = "naturif-broderie-product-notice";
          calculator.appendChild(noticeEl);
        }
        const { ok, text } = broderieNoticeText(qty);
        styleNotice(noticeEl, ok);
        noticeEl.textContent = text;
      }

      calculator.addEventListener("change", function (e) {
        if (e.target.type === "radio") {
          togglePositionare(e.target.value !== "9");
        }
        refreshProductNotice();
      });

      document.addEventListener("cart:updated", refreshProductNotice);
      refreshProductNotice();

      function showCalcError(msg) {
        let err = document.getElementById("naturif-checkbox-error");
        if (!err) {
          err = document.createElement("p");
          err.id = "naturif-checkbox-error";
          err.style.cssText = "color: #e53e3e; font-size: 13px; margin-top: 8px; font-weight: 600;";
          calculator.appendChild(err);
        }
        err.textContent = msg;
        err.scrollIntoView({ behavior: "smooth", block: "center" });
      }

      function removeCalcError() {
        const err = document.getElementById("naturif-checkbox-error");
        if (err) err.remove();
      }

      // Singura validare care mai blochează adăugarea în coș: trebuie aleasă
      // cel puțin o poziție de personalizare. Cantitatea minimă de 20 buc.
      // la broderie NU mai blochează - e doar informativă (vezi notițele de mai jos).
      validateAddToCart = async function () {
        const radios = calculator.querySelectorAll('input[type="radio"]');
        let selectedMethod = null;
        radios.forEach((r) => { if (r.checked) selectedMethod = r.value; });
        if (selectedMethod === "9" || selectedMethod === null) {
          removeCalcError();
          return false;
        }

        const checkboxes = calculator.querySelectorAll('input[type="checkbox"]');
        if (!Array.from(checkboxes).some((c) => c.checked)) {
          showCalcError("Te rugăm să selectezi cel puțin o poziție de personalizare.");
          return true;
        }

        removeCalcError();
        return false;
      };
    })();
  }

  // ---------------------------------------------------------------------
  // Notificare informativă (necesar minim 20 buc./produs la broderie)
  // pe pagina de coș și în cart drawer - NU blochează nimic.
  // ---------------------------------------------------------------------
  function renderBroderieNotices(cart) {
    const groups = getBroderieGroupsFromCart(cart);

    const cartHeader = document.querySelector(".cart__header");
    if (cartHeader) {
      let container = document.getElementById("naturif-broderie-cart-notices");
      if (!container) {
        container = document.createElement("div");
        container.id = "naturif-broderie-cart-notices";
        cartHeader.appendChild(container);
      }
      container.innerHTML = "";
      groups.forEach((g) => {
        const el = document.createElement("div");
        const { ok, text } = broderieNoticeText(g.qty);
        styleNotice(el, ok);
        el.textContent = `${g.title}: ${text}`;
        container.appendChild(el);
      });
    }

    const drawerHeader = document.querySelector("cart-drawer .drawer__header");
    if (drawerHeader) {
      let container = document.getElementById("naturif-broderie-drawer-notices");
      if (!container) {
        container = document.createElement("div");
        container.id = "naturif-broderie-drawer-notices";
        container.style.padding = "0 20px";
        drawerHeader.insertAdjacentElement("afterend", container);
      }
      container.innerHTML = "";
      groups.forEach((g) => {
        const el = document.createElement("div");
        const { ok, text } = broderieNoticeText(g.qty);
        styleNotice(el, ok);
        el.textContent = `${g.title}: ${text}`;
        container.appendChild(el);
      });
    }
  }

  function fetchCartAndRefreshAll() {
    fetch("/cart.js").then((r) => r.json()).then((cart) => {
      renderBroderieNotices(cart);
      updateMinOrderBanner(cart.total_price / 100);
    }).catch(() => {});
  }

  document.addEventListener("cart:updated", fetchCartAndRefreshAll);
  document.addEventListener("cart-update", fetchCartAndRefreshAll);

  // ---------------------------------------------------------------------
  // Interceptare fetch/XHR - doar pentru validarea poziției la /cart/add
  // (cantitatea minimă NU mai blochează adăugarea în coș)
  // ---------------------------------------------------------------------
  const originalFetch = window.fetch;
  window.fetch = function (url, options) {
    const urlStr = typeof url === "string" ? url : (url && url.url) || "";
    const isAdd = urlStr.includes("createSignedQuote") || urlStr.includes("/cart/add");
    if (!isAdd) return originalFetch.apply(this, arguments);

    return validateAddToCart().then((fails) => {
      if (fails) throw new Error("Naturif validation failed");
      return originalFetch.apply(this, arguments);
    });
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._url = url;
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this._url && this._url.includes("/cart/add")) {
      validateAddToCart().then((fails) => {
        if (!fails) originalSend.call(this, body);
      });
      return;
    }
    return originalSend.call(this, body);
  };

  // ---------------------------------------------------------------------
  // Banner valoare minimă coș (doar pe pagina de produs)
  // ---------------------------------------------------------------------
  const buyButtons = document.querySelector(".product__block--buy_buttons");
  let updateMinOrderBanner = function () {};
  if (buyButtons) {
    const banner = document.createElement("div");
    banner.id = "naturif-min-order-banner";
    banner.style.cssText = `
      margin-top: 12px;
      padding: 10px 14px;
      border-radius: 8px;
      font-size: 13px;
      font-weight: 500;
      text-align: center;
      transition: all 0.3s ease;
    `;
    buyButtons.appendChild(banner);

    updateMinOrderBanner = function (cartTotal) {
      const remaining = MIN_ORDER - cartTotal;
      if (remaining <= 0) {
        banner.style.background = "#f0fdf4";
        banner.style.color = "#16a34a";
        banner.style.border = "1px solid #bbf7d0";
        banner.innerHTML = "✓ Poți plasa comanda - valoarea totală a coșului depășește 200 RON" + B2B_NOTA;
      } else {
        banner.style.background = "#fff7ed";
        banner.style.color = "#ea580c";
        banner.style.border = "1px solid #fed7aa";
        banner.innerHTML = `Valoare minimă coș: <strong>200 RON</strong> — Mai ai nevoie de <strong>${remaining.toFixed(2)} RON</strong>` + B2B_NOTA;
      }
    };
  }

  fetchCartAndRefreshAll();

  // ---------------------------------------------------------------------
  // Afișare preț fără TVA + "TVA" peste tot pe site (doar cosmetic -
  // prețurile din Shopify rămân neschimbate, cu TVA inclus; aici doar
  // calculăm și afișăm varianta netă, împărțind la 1.21).
  // ---------------------------------------------------------------------
  (function () {
    const VAT_RATE = 1.21;
    const MONEY_RE = /(\d{1,3}(?:\.\d{3})*|\d+),(\d{2})\s*(lei|RON)/i;

    const style = document.createElement("style");
    style.textContent = ".product__tax, .tax-note { display: none !important; }";
    document.head.appendChild(style);

    function convertText(text) {
      if (/TVA/i.test(text)) return null;
      const m = text.match(MONEY_RE);
      if (!m) return null;
      const integerPart = m[1].replace(/\./g, "");
      const amount = parseFloat(integerPart + "." + m[2]);
      if (Number.isNaN(amount)) return null;
      const net = amount / VAT_RATE;
      const netFormatted = net.toFixed(2).replace(".", ",");
      return text.slice(0, m.index) + netFormatted + " " + m[3] + " + TVA" + text.slice(m.index + m[0].length);
    }

    function scanTextNodes(root) {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          const parent = node.parentElement;
          if (!parent) return NodeFilter.FILTER_REJECT;
          const tag = parent.tagName;
          if (tag === "SCRIPT" || tag === "STYLE" || tag === "NOSCRIPT" || tag === "TEXTAREA" || tag === "INPUT") {
            return NodeFilter.FILTER_REJECT;
          }
          if (parent.closest('[id^="naturif-"]')) return NodeFilter.FILTER_REJECT;
          if (!MONEY_RE.test(node.nodeValue)) return NodeFilter.FILTER_SKIP;
          return NodeFilter.FILTER_ACCEPT;
        },
      });
      const nodes = [];
      let n;
      while ((n = walker.nextNode())) nodes.push(n);
      nodes.forEach((node) => {
        const converted = convertText(node.nodeValue);
        if (converted !== null) node.nodeValue = converted;
      });
    }

    scanTextNodes(document.body);

    let scheduled = false;
    const priceObserver = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        scanTextNodes(document.body);
      });
    });
    priceObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
  })();
});